import { useCallback } from 'react'

import { CROSS_SELL_HOMEPAGE_TOP_FR_FR_ID } from '../cross-sell/api/swr/useSwrCrossSellHorizontalSlider'
import { useGlobalConfigContext } from '../global-config/context/globalConfigContext'

import {
  EXPERIMENTS_TRACK_EVENT_CROSSSELL_INJECTION_SPONSORED_CSW_PRODUCT,
  EXPERIMENTS_TRACK_EVENT_HOME_CSW_PRODUCT,
} from './eventTracking/EXPERIMENTS_TRACK_EVENT'
import { experimentsTrackEvent } from './eventTracking/experimentsTrackEvent'
import { useGetExperiment } from './hooks'
import { EXPERIMENT_NAME_HOME_CROSSSELL_INJECTION } from './model/EXPERIMENT_NAME'
import { EXPERIMENT_VARIATION } from './model/EXPERIMENT_VARIATION'

export const useExperimentsTrackEventCrossSellInjection = (
  widgetId?: number,
): {
  experimentsTrackEventCrossSellInjection: (isSponsoredRow: boolean) => void
} => {
  const config = useGlobalConfigContext()
  const { isEnabled, variant } = useGetExperiment(
    EXPERIMENT_NAME_HOME_CROSSSELL_INJECTION,
  )

  const experimentsTrackEventCrossSellInjection = useCallback(
    (isSponsoredRow: boolean): void => {
      // Early return if conditions not met
      if (
        !widgetId ||
        widgetId !== CROSS_SELL_HOMEPAGE_TOP_FR_FR_ID ||
        !isEnabled
      ) {
        return
      }

      if (isSponsoredRow) {
        const eventName =
          variant === EXPERIMENT_VARIATION.V1
            ? EXPERIMENTS_TRACK_EVENT_CROSSSELL_INJECTION_SPONSORED_CSW_PRODUCT
            : EXPERIMENTS_TRACK_EVENT_HOME_CSW_PRODUCT

        experimentsTrackEvent(config, eventName)
      } else {
        experimentsTrackEvent(config, EXPERIMENTS_TRACK_EVENT_HOME_CSW_PRODUCT)
      }
    },

    [config, isEnabled, widgetId, variant],
  )

  return { experimentsTrackEventCrossSellInjection }
}
